import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import WorksheetActionBySection from '../WorksheetActionBySection';

const WorksheetCheckedBySection = () => (
  <>
    <NamePrefixModifier namePrefix="header">
      <WorksheetActionBySection
        actionBy="CheckedBy"
        actionDate="CheckedDate"
        clearActionTitle="Clear"
        setActionTitle="Set Checker and Date"
        actionByLabel="Checked By"
        actionDateLabel="Date Checked"
        actionHeading="Review"
        clearButtonAlwaysEnabled={true}
      />
    </NamePrefixModifier>
  </>
);

export { WorksheetCheckedBySection };
export default WorksheetCheckedBySection;
